class StorageModel {
    constructor(data, stockInfo) {
        this.stockInfo = stockInfo;

        ko.mapping.fromJS(data, {}, this);
    }
}

export default class StockInfoModel {
    constructor(data) {
        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {
        OnlineStorage: {
            create: (options) => new StorageModel(options.data, this)
        },
        PickupStorage: {
            create: (options) => new StorageModel(options.data, this)
        }
    };

    title = () => {
        return this.StockDisplayType() === 2 ? this.StockQuantityFormatted() + ", " + this.DeliveryTimeFormatted() : this.DeliveryTimeFormatted();
    }

    displayType = ko.pureComputed(() => {
        switch (this.DisplayType()) {
            case 1: return 'traffic-light-tpl';
            case 2: return 'stock-traffic-light-tpl';
            case 3: return 'stock-tpl';
            default: return '';
        }
    });
}